import "core-js/modules/es.string.link.js";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _taggedTemplateLiteral from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { x } from '@xstyled/styled-components';
import { useTranslation } from 'react-i18next';
import ExternalLinkIcon from '../icons/external-link';
import styled from 'styled-components';
var Link = styled(x.a)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: #306ce8;\n  text-decoration: underline;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"])));
export function ExternalLink(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _props$label = props.label,
      label = _props$label === void 0 ? t('ACCESS_LINK') : _props$label,
      link = props.link;
  return /*#__PURE__*/_jsxs(Link, {
    href: link,
    target: "__blank",
    children: [label, " ", /*#__PURE__*/_jsx(ExternalLinkIcon, {
      color: "#306CE8"
    })]
  });
}